<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('fpaManage.permanent.fpaNo')" prop="fpaNo">
                  <!--FPA编号-->
                  <el-input v-model="queryCondition.fpaNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="'Supplier Code'" prop="supplierCode">
                  <!--供应商编号-->
                  <el-input v-model="queryCondition.supplierCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Supplier Name" prop="supplierAbbreviation">
                  <!--供应商简称-->
                  <el-input v-model="queryCondition.supplierAbbreviation" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="'Status'" prop="status">
                  <!--状态-->
                  <ic-select clearable table="TT_FPA_PQCN" field="REPORT_STATUS" v-model="queryCondition.status" style="width:100%"></ic-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('fpaManage.permanent.materialNo')" prop="materialNo">
                    <!--物料编号,支持多个8位码，用英文逗号隔开-->
                    <el-input @input="materialNoChange(queryCondition.materialNo)" type="textarea" :rows="2" :placeholder="$t('fpaManage.permanent.materialNoPlaceHolder')" v-model="queryCondition.materialNo" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('fpaManage.permanent.materialName')" prop="materialName">
                    <!--物料简称-->
                    <el-input v-model="queryCondition.materialName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('fpaManage.permanent.deadline')" prop="startDate" class="flexBox">
                    <!--到期日期-->
                    <el-date-picker v-model="queryCondition.startDate" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd" :picker-options="PickerOptionsStart" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="'To'" prop="endDate" class="flexBox">
                    <el-date-picker v-model="queryCondition.endDate" type="date" :placeholder="$t('common.selDate')" value-format="yyyy-MM-dd" :picker-options="PickerOptionsEnd" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData" type="primary">Search</el-button>
          <el-button size="mini" @click="restQueryFormThis" type="primary">Reset</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button size="mini" type="primary" @click="fpaMaterialReportDownload">Download</el-button>
      <!--FPA物料 3个月内到期数量 : 29  6个月内到期数量 : 29    已过期数量 : 12-->
      {{$t('fpaManage.permanent.materialToExpireCount')}} : {{toExpireCount}} &nbsp;, {{$t('fpaManage.permanent.materialSixMonthExpireCount')}} : {{sixExpiredCount}} &nbsp;, {{$t('fpaManage.permanent.materialExpiredCount')}} : {{expiredCount}}
    </div>
    <el-table :data="tableFpaMaterialList" ref="tableFpaMaterialList" border highlight-current-row max-height='420'>
      <!--FPA编号-->
      <el-table-column show-overflow-tooltip prop="fpaNo" :label="$t('fpaManage.permanent.fpaNo')" width="100px">
      </el-table-column>
      <!-- 供应商Code-->
      <el-table-column show-overflow-tooltip prop="supplierCode" label="Supplier Code" width="120px"></el-table-column>
      <!-- 供应商-->
      <el-table-column show-overflow-tooltip prop="supplierName" label="Supplier Name" max-width="15px"></el-table-column>
      <!-- 工厂Code-->
      <el-table-column show-overflow-tooltip prop="facilityCode" label="Facility Code" width="100px"></el-table-column>
      <!-- 工厂-->
      <el-table-column show-overflow-tooltip prop="facilityName" label="Facility Name" max-width="15px"></el-table-column>
      <!--物料编号-->
      <el-table-column show-overflow-tooltip prop="materialNo" :label="$t('fpaManage.permanent.materialNo')" max-width="15px"></el-table-column>
      <!--物料名称-->
      <el-table-column show-overflow-tooltip prop="materialName" :label="$t('fpaManage.permanent.materialName')" max-width="15px"></el-table-column>
      <!--FPA有效期开始-->
      <el-table-column show-overflow-tooltip prop="agreementStartDate" :label="'Start Date'" width="100px">
        <template slot-scope="scope">
          {{scope.row.agreementStartDate | dateFormatFilter("YYYY-MM-DD")}}
        </template>
      </el-table-column>
      <!--FPA有效期结束-->
      <el-table-column show-overflow-tooltip prop="agreementEndDate" :label="'End Date'" width="100px">
        <template slot-scope="scope">
          {{scope.row.agreementEndDate | dateFormatFilter("YYYY-MM-DD")}}
        </template>
      </el-table-column>
      <!--状态-->
      <el-table-column show-overflow-tooltip prop="status" :label="'Status'" min-width="50px"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import fpaPermanentApi from "@/api/fpa/fpaPermanent";
import { fileService } from "@/api/common/file-utils";

export default {
  components: { IcSelect },
  name: "",

  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        fpaNo: '',
        supplierCode: '',
        supplierAbbreviation: '',
        materialNo: '',
        materialName: '',
        startDate: '',
        endDate: '',
        status: '',
      },
      tableFpaMaterialList: [],
      toExpireCount: 0,
      sixExpiredCount: 0,
      expiredCount: 0,
      totalCount: null,
      PickerOptionsStart: {
        // 开始时间小于结束时间
        disabledDate: time => {
          let endTime = this.queryCondition.endDate;
          if (endTime) {
            return time.getTime() > new Date(endTime).getTime();
          }
        }
      },
      PickerOptionsEnd: {
        disabledDate: time => {
          let beginTime = this.queryCondition.startDate;;
          if (beginTime) {
            return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
          }
        }
      },
    };
  },
  created() {
    this.queryCondition.status = 'all';
    this.queryData();
    this.queryCount();
  },
  methods: {
    materialNoChange(el) {
      console.log("🚀 ~ file: fpaMaterialReport.vue:168 ~ materialNoChange ~ el:", el)
      if (el.indexOf('\n') !== -1) {
        this.queryCondition.materialNo = el.split('\n').join(',')
      }
      console.log('更改后的', this.queryCondition.materialNo)
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      fpaPermanentApi.fpaMaterialReport(this.queryCondition).then(res => {
        this.tableFpaMaterialList = res.resultData;
        this.totalCount = res.totalCount;
      });

    },
    queryCount() {
      fpaPermanentApi.fpaMaterialReportCount().then(res => {
        this.toExpireCount = res.data.toExpireCount;
        this.expiredCount = res.data.expiredCount;
        this.sixExpiredCount = res.data.sixExpiredCount;
      });
    },
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        fpaNo: '',
        supplierCode: '',
        supplierAbbreviation: '',
        materialNo: '',
        materialName: '',
        startDate: '',
        endDate: '',
        status: '',
      }
      this.queryData();
    },
    fpaMaterialReportDownload() {
      fpaPermanentApi.fpaMaterialReportDownload(this.queryCondition).then(res => {
        fileService.respToFile(res, 'FPA物料报表.xls');
      });
    }
  },
  extends: commonFunction
};
</script>
<style scoped  lang="scss">
.el-table {
  margin-top: 10px;
}
.el-select {
  width: 100%;
}
</style>
<style lang="scss">
.text_style {
  display: inline-block;
  position: absolute;
  left: 65px;
}
</style>
